// this mixin is used to wait untill conection to socket is open
// and then to subscribe to a certain resource
// to use it you need to have 'subscribeToResource' method in which
// you are subscribing to resource.
export default {
  data() {
    return {
      socketWatcher: null,
    };
  },

  computed: {
    socketConnected() {
      return this.$store.getters.getSocketConnected;
    },
  },

  methods: {
    tryToSubscribe() {
      if (this.socketConnected) {
        this.subscribeToResource();
      } else {
        this.socketWatcher = this.$watch('socketConnected', (newValue) => {
          if (newValue) {
            this.subscribeToResource();
          }
          this.socketWatcher();
        });
      }
    },
  },
};
